import { render } from "./groom.vue?vue&type=template&id=e97eac88"
import script from "./groom.vue?vue&type=script&lang=js"
export * from "./groom.vue?vue&type=script&lang=js"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__